var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalBasic',{ref:"m",attrs:{"idModal":_vm.idModal,"dialogCentered":true}},[_c('div',[_vm._t("default")],2),_c('button',{staticClass:"btn btn-primary mr-1",on:{"click":function($event){_vm.$emit('yes');
      _vm.hide();}}},[_vm._v(" Si ")]),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.$emit('no');
      _vm.hide();}}},[_vm._v(" No ")])])}
var staticRenderFns = []

export { render, staticRenderFns }